<template>
  <div class="modal warning fade" :class="{ 'is-open': open }" style="">
    <div class="modal-dialog" style="top: 22%;  width:850px;">
      <div class="modal-content">
        <div class="modal-header">
          <a class="close" @click="$emit('close')">
            <i class="icon-close"></i>
          </a>
          <h3 class="modal-title">找不到商品?</h3>
        </div>
        <div class="modal-body">
          <span class="text-style">
            找不到同業商品需新增建檔，請透過<span class="text-red">「簡覆表」</span>方式聯繫： 
          </span><br /><br />
          <span class="text-style">
            以簡覆表告知需新增的同業公司名稱、商品名稱及聯絡方式(以手機為主)，若有條款或DM請協助以附件方式附上，發至以下單位，即會有專人處理。
          </span><br />
          <span class="text-style text-red">
            傳統型商品(非利率變動型)請發至：【商品一科】
          </span><br />
          <span class="text-style text-red">
            傳統型商品(利率變動型)請發至：【商品二科】
          </span><br />
          <span class="text-style text-red" >
            投資型商品請發至：【投資型商品管理二科】
          </span><br />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "mvPopUpProductPrompt",
  data() {
    return {};
  },
  computed: {},
  props: {
    open: {
      type: Boolean,
      default: false,
    },
  },
  methods: {},
};
</script>

<style scoped>
.close {
  position: absolute;
  font-size: 16px;
  width: 24px;
  height: 24px;
  right: 0;
  top: 0;
  margin-right: -12px;
  margin-top: -12px;
  display: block;
  color: #fff;
  text-align: center;
  line-height: 24px;
  padding: 0;
  background: #5b616a;
  border: 1px solid #fff;
  border-radius: 12px;
  -webkit-box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.8);
  -ms-box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.8);
  -o-box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.8);
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.8);
}

.text-style {
  font-family: PingFangTC;
  line-height: 35px;
  font-size: 20px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  color: #323a45;
}
.text-block {
  line-height: 20px;
  padding-left: 20px;
}
</style>